if (!process.env.REACT_APP_BACKEND_URL && process.env.NODE_ENV === "production") {
  throw new Error(
    "REACT_APP_BACKEND_URL is required in production builds. " +
      "Set it to your backend API root URL before running npm run build."
  );
}
const BASE_URL = process.env.REACT_APP_BACKEND_URL
  ? process.env.REACT_APP_BACKEND_URL.replace(/\/?$/, "/")
  : "http://localhost:8080/api/";

export { BASE_URL };
